<template>
  <div>
    <sku-detail v-if="productAuditId || skuId" :sku-id="skuId" :product-audit-id="productAuditId" :if-edit="ifEdit" />
  </div>
</template>

<script>
import SkuDetail from './components/skuDetail.vue';

export default {
  components: { SkuDetail },
  data() {
    return {
      skuId: '',
      productAuditId: '',
      ifEdit: false,
    };
  },
  created() {
    const { productAuditId = '', skuId = '' } = this.$route.query;
    /* if (Object.keys(this.$route.params).length === 0) {
      this.$router.go(-1);
    }
    console.log(this.$route);
    const { productAuditId = "", skuId = "" } = this.$route.params; */
    if (productAuditId && productAuditId.includes('x')) {
      this.productAuditId = +productAuditId.slice(0, -1);
      this.ifEdit = true;
    } else {
      this.productAuditId = +productAuditId;
    }
    this.skuId = +skuId;
  },
  methods: {},
};
</script>
<style lang="scss" scoped></style>
